var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/publishers/series" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("publishers.sub_header.series")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/publishers/non-series-cards" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("publishers.sub_header.non_series_cards")
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary new-series-btn float-right",
                    attrs: { to: "/publishers/create-docx-quizzes" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("publishers.create_docx_quizzes.title")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.nonSeriesCardList.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("publishers.no_cards"))
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.nonSeriesCardList, function(card) {
                      return _c(
                        "div",
                        {
                          key: card.id,
                          staticClass: "col-sm-6 col-md-4 col-lg-3"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-row" },
                            [
                              _c("PublisherCardView", {
                                attrs: { card: card, "is-series-card": false },
                                on: {
                                  "open-add-to-series-modal":
                                    _vm.openAddToSeriesModal
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _vm.addToSeriesModalIsShown
          ? _c("AddToSeriesModal", {
              attrs: {
                "series-list": _vm.seriesList,
                "publisher-id": _vm.publisherId,
                "card-id-for-add-to-series": _vm.cardIdForAddToSeries
              },
              on: {
                cancel: function($event) {
                  return _vm.closeAddToSeriesModal()
                },
                ok: function($event) {
                  return _vm.closeAddToSeriesModal()
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37da1be1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37da1be1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/views/NonSeriesCards.vue
// module id = y0EJ
// module chunks = 1